/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/08/25 09:25
 * @update 2026/08/25 09:25
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, DatePicker, Dropdown, Row, Typography, Label, Button, Checkbox, NumberInput } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W14F1420Actions from "../../../actions/w14/w14F1420/w14F1420-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import { makeStyles, useTheme } from "diginet-core-ui/theme";
import MForm from "../../common/form/form";
import * as templateDropdownActions from "../../../actions/template-dropdown-actions";
import ButtonExport from "../../common/button/button-export";
const { colors } = useTheme();

const useStyles = makeStyles({
    text: {
        marginLeft: "0 !important"
    },
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
});

const initialFilterFields = {
    IsDate: 1,
    DateFrom: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
    DateTo: Config.convertDate(new Date(), "", "MM/DD/YYYY"),
    IsPeriod: 0,
    PeriodFrom: "",
    PeriodTo: "",
    ObjectTypeID: "",
    ObjectID: "",
    StatusID: "",
    SOTypeID: ""
};

const FormID = 'W14F1420';
const requiredField = ['ReportID'];

const W14F1420 = (props) => {
    const classes = useStyles();
    const isMobile = window.innerWidth < 576;
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboDropwDownLoading, setCboDropwDownLoading] = useState({});
    const [dataFilter, setDataFilter] = useState({
        ...initialFilterFields, 
        ReportID: "",
        ReportName: "",
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboDropDown, setCboDropDown] = useState({});
    const [dataCboDropDownPeriod, setCboDropDownPeriod] = useState({});
    const [dataCboAddcol, setCboAddcol] = useState({});
    const [error, setError] = useState({});

    const gridContainer = useRef([]);
    const exportRef = useRef(null);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadCboDropDown('CmbReport', {} , (ReportID) => {
            if (ReportID) {
                loadAddCol(ReportID);
                loadForm(ReportID);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const loadForm = (reportID) => {
        const params = getParamGeneral('loadForm', { ReportID: reportID });
        setFormLoading(true);
        props.W14F1420Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const getDataType = (type) => {
        const value = type?.toLowerCase() || "";
        if (value.includes("date")) return "date";
        if (value.includes("int") || value.includes("decimal") || value.includes("numeric")) return "number";
        if (value.includes("bit")) return "boolean";
        return "string";
    };

    const getDecimalPlace = (type) => {
        const match = type?.match(/(?:decimal|numeric)\(\d+,\s*(\d+)\)/i);
        return match ? Number(match[1]) : 0;
    };

    const renderColDataType = (dataType, decimal) => {
        let colProps = {};
        if (dataType === "number" && decimal > 0) {
            colProps = {
                dataType: 'number',
                alignment: 'right',
                width: 200,
                cellRender: (e) => <NumberInput
                    readOnly
                    nonStyle
                    disabledNegative
                    decimalDigit={decimal}
                    thousandSeparator={','}
                    value={e?.value}
                    className={classes.moneyInputColumn}
                />
            };

        } else if (dataType === "date") {
            colProps = {
                alignment: 'center',
                dataType: 'date',
                format: 'dd/MM/yyyy'
            };
        }
        else if (dataType === "number") {
            colProps = {
                alignment: 'right',
                dataType: 'number',
            };
        }
        return colProps;
    }
    const loadAddCol = (reportID) => {
        const params = getParamGeneral('Addcol', { ReportID: reportID });
        setFormLoading(true);
        props.W14F1420Actions.loadAddCol(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const arrCol = [];
                const arrColCal = [];
                for (let i = 0; i < data.length; i++) {
                    const col = {
                        caption: data[i]?.Caption,
                        dataField: data[i]?.FieldName,
                        dataType: getDataType(data[i]?.Datatype),
                        isSumfooter: data[i]?.IsSumfooter,
                        decimalPlace: getDecimalPlace(data[i]?.Datatype),
                    };
                    const dataTypeCell = renderColDataType(col.dataType, col.decimalPlace);
                    arrCol.push(<Column
                        key={col.dataField}
                        dataField={col.dataField}
                        caption={col.caption}
                        dataType={col.dataType}
                        {...dataTypeCell}
                    />)
                    if (col.isSumfooter === 1) arrColCal.push(<TotalItem
                        key={col.dataField}
                        column={col.dataField}
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, col.decimalPlace)}
                    />)
                }
                setCboAddcol({
                    arrCol, arrColCal
                });
            }
        });
    };

    const loadCboDropDown = (dataType, filterData = {}, cb = () => {}) => {
        const params = getParamGeneral(dataType, filterData);
        setCboDropwDownLoading(prev => ({
            ...prev,
            [dataType]: true
        }));
        props.W14F1420Actions.loadCmbDD(params, (error, data) => {
            setCboDropwDownLoading(prev => ({
                ...prev,
                [dataType]: false
            }));
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                let ReportID = '';
                if (dataType === "CmbReport") {
                    ReportID = data?.[0]?.ReportID || '';
                    setDataFilter({ ...dataFilter, ReportID }); // default
                }
                setCboDropDown(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
                if (dataType === 'CmbReport' && cb) {
                    cb(ReportID);
                }
            }
        });
    };

    const loadDropDowmPeriod = (dataType, data) => {
        const params = getParamGeneral(dataType, data);
        setCboDropwDownLoading(prev => ({
            ...prev,
            [dataType]: true
        }));
        props.W14F1420Actions.loadDropDowmPeriod(params, (error, data) => {
            setCboDropwDownLoading(prev => ({
                ...prev,
                [dataType]: false
            }));
            setCboDropwDownLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setCboDropDownPeriod(prev => ({
                    ...prev,
                    [dataType]: data || []
                }));
            }
        });
    };

    const dataSourceDropDown = (dataType) => {
        return dataCboDropDown[dataType] || [];
    };

    const dataSourceDropDownPeriod = (dataType) => {
        return dataCboDropDownPeriod[dataType] || [];
    };

    const onOpenLoaded = (data = {}) => {
        loadCboDropDown('CmbObType', data);
        loadCboDropDown('CmbObID', data);
        loadCboDropDown('StatusID', data);
        loadCboDropDown('SOType', data);
        loadDropDowmPeriod('CmbPeriodF', data);
        loadDropDowmPeriod('CmbPeriodT', data);
    };

    const getParamGeneral = (type, data = {}) => {
        const { ReportID = "", IsDate, DateFrom = null, DateTo = null, IsPeriod, PeriodFrom = null, PeriodTo = null, ObjectTypeID = "", ObjectID = "", StatusID = "", SOTypeID = "" } = dataFilter;
        let params = {
            DataType: type,
            ReportID: data?.ReportID || ReportID,
            IsDate,
            DateFrom,
            DateTo,
            IsPeriod,
            PeriodFrom,
            PeriodTo,
            ObjectTypeID: data?.ObjectTypeID || ObjectTypeID,
            ObjectID,
            StatusID,
            SOTypeID
        };
        return params;
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'Success',
            align: 'right',
            disabled: false,
            onClick: () => {
                const instance = exportRef.current?.getWrappedInstance();
                if (instance?.onClick) instance.onClick(0);
            }
        }];

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataFilter[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const require = () => {
        const resultValidate = checkValidateMaster(requiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            return false;
        }
        return true;
    }

    const onSearch = () => {
        if (!require() || Config.isEmpty(dataFilter?.ReportID)) return;
        loadAddCol();
        loadForm();
    };

    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value;
        if (['IsDate', 'IsPeriod'].includes(keyName)) {
            const checked = e?.target?.checked ?? e?.checked ?? e?.value ?? e;
            value = checked ? 1 : 0;
        } else value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = {
            ...dataFilter,
            [keyName]: value,
        };
        switch (keyName) {
            case "ReportID":
                objPlus = {
                    ...objPlus,
                    ...initialFilterFields,
                    ReportID: value,
                    ReportName: e?.data?.ReportName
                };
                onOpenLoaded({ReportID: value});
                break;
            case "IsDate":
                if (value === 1) {
                    objPlus.IsPeriod = 0;
                } else {
                    objPlus.IsPeriod = 1;
                }
                break;
            case "IsPeriod":
                if (value === 1) {
                    objPlus.IsDate = 0;
                } else {
                    objPlus.IsDate = 1;
                }
                break;
            case "WareHouseID":
                objPlus.WareHouseName = e?.data?.WareHouseName
                break;
            case "ObjectTypeID":
                objPlus.ObjectTypeName = e?.data?.ObjectTypeName;
                objPlus.ObjectID = ''; 
                objPlus.ObjectName = '';
                loadCboDropDown('CmbObID', {ObjectTypeID: value});
                break;
            default:
                break;
        }
        setDataFilter(objPlus);
        if (!Config.isEmpty(value) && error?.[keyName]) setError({ ...error, [keyName]: '' });
    };

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row>
                    <Col xs={12} sm={3} className={'pdl0'} verticalAlign={"center"} >
                        <Checkbox
                            className="mgl4x"
                            label={Config.lang('Ngay')}
                            labelProps={{ type: "h4", color: colors.text.label, whiteSpace: 'nowrap' }}
                            checked={Number(dataFilter?.IsDate) === 1}
                            onChange={(e) => onChangeFilter("IsDate", e)}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <DatePicker
                            clearAble
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            disabled={dataFilter?.IsDate !== 1}
                            placeholder={Config.lang('Tu')}
                            max={dataFilter?.DateTo}
                            value={dataFilter?.DateFrom}
                            onChange={e => onChangeFilter('DateFrom', e)}
                        />
                    </Col>
                    {!isMobile &&
                        <Col xs={12} sm={1} className={"pdl0 display_row valign-middle align-center"}>
                            <Typography type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                        </Col>
                    }
                    <Col xs={12} sm={4} className={!isMobile ? 'pdl0' : ""}>
                        <DatePicker
                            clearAble
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            disabled={dataFilter?.IsDate !== 1}
                            placeholder={Config.lang('Den')}
                            min={dataFilter?.DateFrom}
                            value={dataFilter?.DateTo}
                            onChange={e => onChangeFilter('DateTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={3}>
                        <Typography className={isMobile ? classes.text : "mgl4x"} type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Nhom_doi_tuong")}</Typography>
                    </Col>
                    <Col xs={12} sm={9}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'ObjectTypeID'}
                            displayExpr={'ObjectTypeName'}
                            loading={cboDropwDownLoading['CmbObType']}
                            dataSource={dataSourceDropDown('CmbObType')}
                            value={dataFilter?.ObjectTypeID}
                            onChange={e => onChangeFilter('ObjectTypeID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row>
                    <Col xs={12} sm={3} className={'pdl0'} verticalAlign={"center"} >
                        <Checkbox
                            className="mgl4x"
                            label={Config.lang('Ky')}
                            labelProps={{ type: "h4", color: colors.text.label }}
                            checked={Number(dataFilter?.IsPeriod) === 1}
                            onChange={(e) => onChangeFilter("IsPeriod", e)}
                        />
                    </Col>
                    <Col xs={12} sm={4}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'PeriodFrom'}
                            displayExpr={'PeriodName'}
                            loading={cboDropwDownLoading['CmbPeriodF']}
                            disabled={dataFilter?.IsPeriod !== 1}
                            dataSource={dataSourceDropDownPeriod('CmbPeriodF')}
                            placeholder={Config.lang('Tu')}
                            value={dataFilter?.PeriodFrom}
                            className={'full_w'}
                            onChange={e => onChangeFilter('PeriodFrom', e)}
                        />
                    </Col>
                    {!isMobile &&
                        <Col xs={12} sm={1} className={"pdl0 display_row valign-middle align-center"}>
                            <Typography type='p1' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>-</Typography>
                        </Col>
                    }
                    <Col xs={12} sm={4} className={!isMobile ? 'pdl0' : ""}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'PeriodTo'}
                            displayExpr={'PeriodName'}
                            loading={cboDropwDownLoading['CmbPeriodT']}
                            disabled={dataFilter?.IsPeriod !== 1}
                            dataSource={dataSourceDropDownPeriod('CmbPeriodT')}
                            placeholder={Config.lang('Den')}
                            value={dataFilter?.PeriodTo}
                            onChange={e => onChangeFilter('PeriodTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={3}>
                        <Typography className={isMobile ? classes.text : "mgl4x"} type='h4' lineClamp={1} color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Doi_tuong")}</Typography>
                    </Col>
                    <Col xs={12} sm={9}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'ObjectID'}
                            displayExpr={'ObjectName'}
                            loading={cboDropwDownLoading['CmbObID']}
                            dataSource={dataSourceDropDown('CmbObID')}
                            value={dataFilter?.ObjectID}
                            onChange={e => onChangeFilter('ObjectID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={3}>
                        <Typography className="mgr4x" type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Trang_thai")}</Typography>
                    </Col>
                    <Col xs={12} sm={9}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'StatusID'}
                            displayExpr={'StatusName'}
                            loading={cboDropwDownLoading['StatusID']}
                            dataSource={dataSourceDropDown('StatusID')}
                            value={dataFilter?.StatusID}
                            onChange={e => onChangeFilter('StatusID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Row className={"display_row align-center"}>
                    <Col xs={12} sm={3}>
                        <Typography className={isMobile ? classes.text : "mgl4x"} type='h4' color={colors.text.label} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Loai_don_hang")}</Typography>
                    </Col>
                    <Col xs={12} sm={9}>
                        <Dropdown
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'SOTypeID'}
                            displayExpr={'SOTypeName'}
                            loading={cboDropwDownLoading['SOType']}
                            dataSource={dataSourceDropDown('SOType')}
                            value={dataFilter?.SOTypeID}
                            onChange={e => onChangeFilter('SOTypeID', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={2} lg={2} className={'display_row valign-bottom'} verticalAlign={'end'}>
                <Button
                    style={{ backgroundColor: "white" }}
                    startIcon={"Search"}
                    viewType={"outlined"}
                    label={Config.lang("Tim_kiem")}
                    onClick={onSearch}
                />
            </Col>
        </Row>
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                isShowFilter
                reference={(ref) => gridContainer.current = ref}
                dataSource={dataGrid}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                keyExpr={'OrderNo'}
                pagerFullScreen
                itemPerPage={80}
                listPerPage={[80, 160, 240, 320]}
                elementAttr={{ style: 'max-height: 510px; min-height: 320px' }}
                filterRender={filterRender()}
                onSearch={onSearch}
                showSearchInput={false}
                onOpenLoaded={onOpenLoaded}
            >
                {dataCboAddcol?.arrCol && dataCboAddcol.arrCol}
                <Summary>
                    {dataCboAddcol?.arrColCal && dataCboAddcol.arrColCal}
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, cboDropwDownLoading, dataCboAddcol, dataSourceDropDown, dataFilter]);

    const reportID = dataCboDropDown?.[0]?.ReportID || dataFilter?.ReportID;

    const paramExport = [
        { id: "UserID", type: "Varchar", value: Config.profile.UserID },
        { id: "Language", type: "Varchar", value: Config.language || '84' },
        { id: "DivisionID", type: "VarChar", value: Config.profile.DivisionID || "" },
        { id: "ReportID", type: "VarChar", value: reportID },
        { id: "IsDate", type: "TINYINT", value: dataFilter?.IsDate },
        { id: "DateFrom", type: "DATETIME", value: dataFilter?.DateFrom },
        { id: "DateTo", type: "DATETIME", value: dataFilter?.DateTo },
        { id: "IsPeriod", type: "TINYINT", value: dataFilter?.IsPeriod },
        { id: "PeriodFrom", type: "DATETIME", value: dataFilter?.PeriodFrom },
        { id: "PeriodTo", type: "DATETIME", value: dataFilter?.PeriodTo },
        { id: "ObjectTypeID", type: "VarChar", value: dataFilter?.ObjectTypeID },
        { id: "ObjectID", type: "VarChar", value: dataFilter?.ObjectID },
        { id: "StatusID", type: "VarChar", value: dataFilter?.StatusID },
        { id: "SOTypeID", type: "VarChar", value: dataFilter?.SOTypeID },
    ];

    if (!iPermission) return null;

    return (
        <div className={'page-container'} style={{ height: '100vh' }}>
            <ButtonExport
                className={"hide"}
                ref={ref => exportRef.current = ref}
                reportTypeID={"W14F1420"}
                id={'slave1'}
                name={Config.lang('In1')}
                onlyShowPopup
                param={paramExport}
            />
            <ActionToolbar title={Config.lang("Bao_cao_hoa_hong")} >
                <Row>
                    <Col xs={12} className={"display_row align-center valign-bottom"}>
                        <Label required style={{ whiteSpace: 'nowrap' }}>{Config.lang('Mau_bao_cao')}</Label>
                        <Dropdown
                            required
                            clearAble
                            className={'mgl4x'}
                            viewType={'outlined'}
                            valueExpr={'ReportID'}
                            displayExpr={'ReportName'}
                            loading={cboDropwDownLoading['CmbReport']}
                            dataSource={dataSourceDropDown('CmbReport')}
                            value={dataFilter?.ReportID}
                            error={error?.ReportID}
                            style={{ minWidth: 200 }}
                            onChange={e => onChangeFilter('ReportID', e)}
                        />
                    </Col>
                </Row>
            </ActionToolbar>
            <Row><Col xs={12}>{renderGrid}</Col></Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W14F1420Actions: bindActionCreators(W14F1420Actions, dispatch),
    templateDropdownActions: bindActionCreators(templateDropdownActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W14F1420);